<div class="ag-grid-evrideo-header-container">
  <div class="selection">
    <span> {{ selectedCount }} items selected </span>
  </div>
  <div class="action-buttons">
    <ng-content></ng-content>
  </div>
</div>
